import React from "react"
import { Card } from "reactstrap"
import styles from "./PBPCourt.module.scss"
import { gridColumns, gridRows } from "../../../utility/constants/gridSize"

const PBPCourt = ({ events, eventIndex, eventIndexWentUp }) => {
	const homeTeamName = JSON.parse(localStorage.getItem("homeTeam") ?? {}).name
	const homeTeam = JSON.parse(localStorage.getItem("homeTeam"))
	const awayTeam = JSON.parse(localStorage.getItem("awayTeam"))

	const createGridRow = (y) => {
		const columns = []
		for (let x = 0; x < gridColumns; x++) {
			columns.push(
				<div key={`btn-${x}-${y}`} className={styles.gridCol}></div>
			)
		}
		return columns
	}

	const createGrid = () => {
		const rows = []
		for (let y = 0; y < gridRows; y++) {
			rows.push(createGridRow(y))
		}

		addEvents(rows)

		return (
			<div className={styles.grid}>
				{rows.map((row, index) => (
					<div key={`row-${index}`} className={styles.gridRow}>
						{row}
					</div>
				))}
			</div>
		)
	}

	const addEvents = (rows) => {
		for (let i = eventIndex; i >= 0 && i > eventIndex - 3; i--) {
			addPlayer(rows, events[i], i === eventIndex)
		}

		if (eventIndexWentUp && events[eventIndex - 3]) {
			addPlayer(rows, events[eventIndex - 3], false, true)
		} else if (!eventIndexWentUp && events[eventIndex + 1]) {
			addPlayer(rows, events[eventIndex + 1], false, true)
		}
	}

	const addPlayer = (rows, event, isNew, isDone) => {
		const { team, coordinates } = event ?? {}

		if (team == homeTeam.name) {
			homeTeam.players.map((player) => {
				if (player.playerId == event.playerId) {
					event.tshirtNumber = player.tshirtNumber
				}
			})
		} else if (team == awayTeam.name) {
			awayTeam.players.map((player) => {
				if (player.playerId == event.playerId) {
					event.tshirtNumber = player.tshirtNumber
				}
			})
		}

	/* 	console.log("Event ", event) */

		if (!coordinates) return

		const { x, y } = coordinates

		const newCircle = {
			border: "3px solid $white",
			zIndex: 1,
			borderRadius: "100%",
			width: "150%",
			height: "140%",
		}

		const hideCircle = {
			animation: "hideSpan 0.2s",
			opacity: 0,
		}

		const awayTeamStyles = {
			backgroundColor: "rgba(250, 182, 182, 0.9)",
		}

		rows[y][x] = (
			<div key={`btn-${x}-${y}`} className={styles.gridCol}>
				<i
					className={`fas fa-tshirt
						${isNew ? styles.newCircle : isDone ? styles.hideCircle : ""}
						
						`}
					style={
						team !== homeTeamName
							? {
									color: `${
										awayTeam.jerseyColor?.jersey
											? awayTeam.jerseyColor?.jersey
											: "red"
									}`,
							  }
							: {
									color: `${
										homeTeam.jerseyColor?.jersey
											? homeTeam.jerseyColor?.jersey
											: "blue"
									}`,
							  }
					}
				>
					{" "}
					<span
						style={
							team !== homeTeamName
								? {
										color: `${
											awayTeam.jerseyColor?.number
												? awayTeam.jerseyColor?.number
												: "white"
										}`,
										fontSize: "large",
										position: "absolute",
										top: "50%",
										right: "50%",
										transform: "translate(50%, -50%)",
								  }
								: {
										color: `${
											homeTeam.jerseyColor?.number
												? homeTeam.jerseyColor?.number
												: "white"
										}`,
										fontSize: "large",
										position: "absolute",
										top: "50%",
										right: "50%",
										transform: "translate(50%, -50%)",
								  }
						}
					>
						{event.tshirtNumber}
					</span>
				</i>
			</div>
		)
	}

	return (
		<Card className={styles.courtWrapper}>
			<div
				className={`
					${styles.courtRatio}
					${styles[localStorage.getItem("sport").toLowerCase()]}
				 `}
			>
				{createGrid()}
			</div>
		</Card>
	)
}

export default PBPCourt
